import React from 'react';
import { CheckCircle2, ShieldCheck, Lock } from 'lucide-react';
import { motion } from 'framer-motion';
import { useCountdown } from './Countdown';
export function Pricing() {
  const {
    minutes,
    seconds
  } = useCountdown(3, 58); // Starts at 03:58 as requested
  return <section className="w-full bg-navy py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-117">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-118">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-primary/5 blur-[120px]" data-id="element-119"></div>
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-primary/5 blur-[120px]" data-id="element-120"></div>
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-121">
        <div className="text-center mb-12" data-id="element-122">
          <h2 className="text-3xl sm:text-5xl font-heading font-black text-white mb-4" data-id="element-123">
            Todo lo que incluye tu compra
          </h2>
          <p className="text-gray-300 text-lg" data-id="element-124">
            Acceso inmediato a todo esto por un único pago.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2rem] p-6 sm:p-10 shadow-2xl" data-id="element-125">
          <div className="space-y-4 mb-10" data-id="element-126">
            <div className="flex items-center justify-between gap-4 py-3 border-b border-gray-100" data-id="element-127">
              <div className="flex items-center gap-3" data-id="element-128">
                <CheckCircle2 className="w-5 h-5 text-navy" data-id="element-129" />
                <span className="font-bold text-navy" data-id="element-130">
                  PROFE PACK (Biblioteca 6 Volúmenes)
                </span>
              </div>
              <span className="font-bold text-navy" data-id="element-131">47 USD</span>
            </div>

            {['Bono #1 · 50 Calentamientos', 'Bono #2 · Juegos de Cierre', 'Bono #3 · Clases Especiales', 'Bono #4 · Kit de Consignas', 'Bono #5 · Plantillas Semanales'].map((bono, idx) => <div key={idx} className="flex items-center justify-between gap-4 py-3 border-b border-gray-100" data-id="element-132">
                <div className="flex items-center gap-3" data-id="element-133">
                  <CheckCircle2 className="w-5 h-5 text-success" data-id="element-134" />
                  <span className="font-medium text-gray-700" data-id="element-135">{bono}</span>
                </div>
                <span className="font-bold text-success" data-id="element-136">GRATIS</span>
              </div>)}

            <div className="flex items-center justify-between gap-4 py-3" data-id="element-137">
              <div className="flex items-center gap-3" data-id="element-138">
                <ShieldCheck className="w-5 h-5 text-primary" data-id="element-139" />
                <span className="font-bold text-navy" data-id="element-140">Garantía de 7 días</span>
              </div>
              <span className="font-bold text-primary" data-id="element-141">INCLUIDA</span>
            </div>
          </div>

          <div className="text-center mb-8" data-id="element-142">
            <p className="text-gray-500 mb-2" data-id="element-143">
              Valor total regular <span className="line-through" data-id="element-144">232 USD</span>
            </p>
            <div className="inline-block bg-primary/10 text-primary font-bold px-4 py-1 rounded-full text-sm mb-4 uppercase tracking-wider" data-id="element-145">
              Oferta de hoy
            </div>
            <div className="text-5xl sm:text-6xl font-heading font-black text-navy mb-2" data-id="element-146">
              17 USD
            </div>
            <p className="text-gray-600 font-medium" data-id="element-147">
              Precio único · Acceso de por vida
            </p>
          </div>

          <div className="bg-cream-dark/50 rounded-2xl p-6 mb-8 text-center border border-gray-100" data-id="element-148">
            <p className="text-sm font-bold text-navy uppercase tracking-wider mb-3" data-id="element-149">
              Esta oferta expira en
            </p>
            <div className="flex items-center justify-center gap-4 font-heading font-black" data-id="element-150">
              <div className="flex flex-col items-center" data-id="element-151">
                <div className="bg-navy text-white text-4xl sm:text-5xl rounded-xl w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center shadow-inner" data-id="element-152">
                  {minutes}
                </div>
                <span className="text-[10px] uppercase tracking-widest text-gray-500 mt-2 font-sans font-bold" data-id="element-153">
                  MIN
                </span>
              </div>
              <div className="text-3xl text-navy pb-6" data-id="element-154">:</div>
              <div className="flex flex-col items-center" data-id="element-155">
                <div className="bg-navy text-white text-4xl sm:text-5xl rounded-xl w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center shadow-inner" data-id="element-156">
                  {seconds}
                </div>
                <span className="text-[10px] uppercase tracking-widest text-gray-500 mt-2 font-sans font-bold" data-id="element-157">
                  SEG
                </span>
              </div>
            </div>
          </div>

          <button className="w-full bg-primary hover:bg-primary-hover text-white font-heading font-black text-xl sm:text-2xl py-5 rounded-xl shadow-[0_8px_24px_0_rgba(241,90,41,0.4)] transition-all transform hover:-translate-y-1 mb-4 flex flex-col items-center justify-center gap-1" data-id="element-158">
            <span data-id="element-159">Finalizar compra — 17 USD</span>
            <span className="text-sm font-sans font-medium text-white/90" data-id="element-160">
              Ahorrás 215 USD
            </span>
          </button>

          <div className="flex items-center justify-center gap-4 text-xs font-medium text-gray-500" data-id="element-161">
            <span className="flex items-center gap-1" data-id="element-162">
              <ShieldCheck className="w-4 h-4" data-id="element-163" /> Garantía de devolución de 7
              días
            </span>
            <span className="hidden sm:inline text-gray-300" data-id="element-164">•</span>
            <span className="flex items-center gap-1" data-id="element-165">
              <Lock className="w-4 h-4" data-id="element-166" /> Compra 100% segura
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}